/* eslint-disable */
import DatePanel from '../panel/date'
import Picker from '../picker'

export default {
  mixins: [Picker],

  name: 'ElDatePickerCustom',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean,
    markedDates: {
      type: Array,
      default: () => []
    }
  },

  created () {
    this.panel = DatePanel
  }
}
